import client from './client';

const Accounting = {
  getAccounting(anketId) {
    return client.get(`/ankets/${anketId}/kf_analytics/accounting`);
  },
};

export default Accounting;
